import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Tabela from "../../components/Tabela";
import { getChecklistById } from "../../api/checkilstApi";
import { toast } from "react-toastify";
import { Checklist, GrupoPergunta } from "../../types/checklistData";

const GruposPerguntas: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [grupos, setGrupos] = useState<GrupoPergunta[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const checklistData: Checklist = await getChecklistById(token, id!);
        setGrupos(checklistData.grupo_perguntas);
      } catch (error) {
        toast.error("Erro ao buscar Checklist!");
        console.error("Erro ao buscar Checklist:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChecklist();
  }, [id]);

  const handleEditGrupoPergunta = (id: string) => {
    navigate(`/editarGrupoPergunta/${id}`);
  };

  const handleViewPerguntas = (id: string) => {
    navigate(`/grupoPerguntas/${id}/perguntas`);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_checklist_grupo", label: "Descrição do Grupo" },
  ];

  const dadosConvertidos = grupos.map((grupo) => ({
    ...grupo,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Grupos de Perguntas"
        colunas={colunas}
        dados={dadosConvertidos}
        loading={loading}
        showVisibilityIcon={true}
        onView={handleViewPerguntas}
        onEdit={handleEditGrupoPergunta}
        showBackButton={true}
        onBack={handleBack}
      />
    </Box>
  );
};

export default GruposPerguntas;
